import React, { useState, memo, useCallback, useContext, useEffect } from 'react';
import IconChevronUp from 'Icon/svg/IconChevronUp';
import IconChevronDown from 'Icon/svg/IconChevronDown';

const DropdownContext = React.createContext();

const Button = ({
  type, className, text, children, style, styleContainer, styleOptionContainer, disabled, onSelect
}) => {
  const [open, setOpen] = useState(false);
  const [textDisplay, setTextDisplay] = useState(text);
  useEffect(() => {
    setOpen(false);
  }, [disabled]);
  useEffect(() => {
    setTextDisplay(text);
  }, [text]);
  const handleClick = useCallback((e) => {
    const { value } = e.target.dataset;
    const { dropdownText } = e.target.dataset;
    setTextDisplay(dropdownText);
    setOpen(false);
    if (onSelect) {
      onSelect(value);
    }
  });
  let classNameOptions = 'dropdown-options';
  if (type === 'dropup') {
    classNameOptions = 'dropdup-options';
  }
  return (
    <div className={`ajaib-dropdown ${className || ''} ${disabled ? 'disabled' : ''}`} style={style}>
      <div 
        className="dropdown-button-container"
        onClick={() => (disabled ? null : setOpen(!open))}
        style={styleContainer}
        role="button"
      >
        {textDisplay}
        <div className="dropdown-icon-container">
          {
            open ? (
              <IconChevronUp className="icon" />
            ) : (
              <IconChevronDown className="icon" />
            )
          }
        </div>
      </div>
      {
        open && (
          <div className={classNameOptions} style={styleOptionContainer}>
            <div className="options-container">
              <DropdownContext.Provider value={handleClick}>
                {children}
              </DropdownContext.Provider>
            </div>
          </div>
        )
      }
    </div>
  );
};

const Option = ({
  value, children,
}) => {
  const onClick = useContext(DropdownContext);
  return (
    <div 
      className="option-item"
      onClick={onClick}
      data-value={value}
      data-text={children}
      role="button"
    >
      {children}
    </div>
  );
};

const Dropdown = {
  Button: memo(Button),
  Option: memo(Option),
};

export default Dropdown;
